module.exports = __webpack_public_path__ + "img/piece-locked-5.3c651bb4.svg";